import { getAllFences } from "@/api/fences.ts";
import { convertFenceToFeatureCollection } from "@/utils/data-helper.ts";
import { defineStore } from "pinia";
import { manageApiCall } from "@movinglayers/api";
import { computed, ref, watch } from "vue";
import { useStorageStore } from "./storage.ts";

export const useFenceStore = defineStore("fence", () => {

    const storageStore = useStorageStore();
    const fences: any = ref([]);

    const fenceFeatureCollection = computed(() => {
        return convertFenceToFeatureCollection(fences.value);
    });

    const retrieveFences = async () => {
        // @ts-ignore some unexpected ts error, TODO: follow this issue: https://github.com/axios/axios/issues/6692
        const call = manageApiCall(getAllFences);

        const response = await call.makeRequest();
        return response.data.data;
    };

    const retrieveAndStoreFences = async () => {
        const data = await retrieveFences();
        fences.value = data;
        return data;
    };

    const readFromStorage = async () => {
        const storedFences = storageStore.controller.fences.get();
        if (storedFences) {
            fences.value = storedFences;
        }
    }

    watch(fences, (newFences) => {
        const unproxied = JSON.parse(JSON.stringify(newFences)); //TODO: find a better way to deep clone
        storageStore.controller.fences.set(unproxied);
    });

    return { fences, fenceFeatureCollection, retrieveAndStoreFences, readFromStorage };
});